import type { ComponentPropsWithRef } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './button.module.scss';

export type ButtonVariant = 'primary' | 'ink' | 'light' | 'ghost' | 'outline';
export type ButtonSize = 'sm' | 'md' | 'lg';
export type ButtonStyleProps = {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
};

export function buttonClassName({ fullWidth = false }: ButtonStyleProps, className?: string) {
  return cx(styles.root, fullWidth && styles.full, className);
}

export type ButtonProps = ComponentPropsWithRef<'button'> &
  ButtonStyleProps & { loading?: boolean };

export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  loading = false,
  fullWidth = false,
  disabled,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      className={buttonClassName({ fullWidth }, className)}
      type={type}
      data-variant={variant}
      data-size={size}
      data-loading={loading || undefined}
      aria-busy={loading || undefined}
      disabled={disabled || loading}
    >
      {loading && <span className={styles.spinner} aria-hidden="true" />}
      {children}
    </button>
  );
}
